import { Button, Flex } from 'antd';

import styled from '@emotion/styled';

export const Item = styled(Flex)`
  /* min-height, not height: a generated line can carry a two-line description (the
     billing period plus, for intermediation, what the charge is), which a fixed height
     would clip. */
  min-height: 66px;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.strokeDarkGrey};
  cursor: default;
  padding: 8px;
  margin-bottom: 4px;
  position: relative;

  &.service-item--manageable {
    cursor: pointer;
  }

  &.service-item--manageable:hover,
  &.service-item--manageable:focus-within {
    background-color: ${({ theme }) => theme.colors.bgGrey};

    .service-amount {
      display: none;
    }

    .service-actions {
      display: flex;
    }
  }
`;

export const Title = styled.div`
  font-weight: 600;
  flex: 1;
`;

/* Line descriptions are stored with real newlines, which HTML would otherwise collapse
   into a single space. */
export const Description = styled.div`
  white-space: pre-line;
`;

export const Actions = styled(Flex)`
  display: none;
`;

export const ButtonEdit = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.blackSecondary};
  }
`;

export const ButtonDelete = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.red};
  }
`;
